
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form';
import moment from 'moment';

@Component({
  components: {
  },
})
export default class extends Vue {
  @Prop({ required: true }) private pricePartList!: any;

  mounted() {
    this.pricePartList.forEach((pricePart: any) => {
      this.formData.pricePartList.push({
        ...pricePart,
        dateRange: [pricePart.startDate, pricePart.endDate],
      });
    });
  }

  private loading = true;

  private formData: any = {
    pricePartList: [],
  };

  // 행별 picker-options: 자기 자신의 기간은 겹침 검사에서 제외 (수정 가능하도록)
  private getPickerOptions(selfIndex: number) {
    return {
      disabledDate: (time: any) => this.disabledDate(time, selfIndex),
    };
  }

  /* eslint-disable */
  private disabledDate(time: any, selfIndex: number) {
    let duplicated = false;
    if (this.formData.pricePartList.length > 0) {
      this.formData.pricePartList.forEach((pricePart: any, index: number) => {
        if (index === selfIndex) return;
        const targetDate = moment(time).format('YYYY-MM-DD');
        if (
          moment(targetDate).isBetween(moment(pricePart.startDate), moment(pricePart.endDate)) ||
          moment(targetDate).isSame(moment(pricePart.startDate)) ||
          moment(targetDate).isSame(moment(pricePart.endDate))
        ) {
          duplicated = true;
        }
      });
    }
    return time < new Date() || duplicated;
  }
  /* eslint-enable */

  private validateDateRange = (rule:any, value:any, callback:any) => {
    if (!value || value.length === 0) callback(new Error('기간을 입력해주세요.'));
    let isValid = true;
    const startDate = value[0];
    const endDate = value[1];
    this.formData.pricePartList.forEach((pricePart: any, index: number) => {
      if (
        (pricePart.startDate >= startDate && pricePart.startDate <= endDate)
        || (pricePart.endDate >= startDate && pricePart.endDate <= endDate)
      ) {
        isValid = false;
      }
    });
    if (!isValid) callback(new Error('해당 기간은 이미 일정이 존재합니다.'));
    callback();
  };

  private rules = {
    name: [
      { required: true, message: '일정명을 입력해주세요.', trigger: ['blur', 'change'] },
    ],
    dateRange: [
      { validator: this.validateDateRange, trigger: ['blur', 'change'] },
    ],
  }

  private handleSavePricePart() {
    (this.$refs.formRef as ElForm).validate((valid: boolean) => {
      if (valid) {
        this.$emit('save', this.formData.pricePartList);
        console.log(this.formData.pricePartList);
      }
    });
  }

  private handleAddPricePart() {
    this.formData.pricePartList.push({
      name: '',
      startDate: '',
      endDate: '',
      dateRange: [],
    });
  }

  private handleDeletePricePart(index: number) {
    this.$confirm('정말 요금타입을 삭제하시겠습니까?', '요금타입 삭제', {
      confirmButtonText: '예',
      cancelButtonText: '아니오',
      type: 'info',
    }).then(() => {
      this.formData.pricePartList.splice(index, 1);
      this.$emit('delete', index);
    });
  }

  /* eslint-disable */
  private handleChangeDateRange(pricePart: any) {
    if (pricePart.dateRange && pricePart.dateRange.length === 2) {
      pricePart.startDate = pricePart.dateRange[0];
      pricePart.endDate = pricePart.dateRange[1];
    } else {
      pricePart.startDate = '';
      pricePart.endDate = '';
    }
  }
  /* eslint-enable */
}
